var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegumes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1198 14.0005C18.1198 11.7288 16.2717 9.88074 14 9.88074C11.7283 9.88074 9.88022 11.7288 9.88022 14.0005C9.88022 16.2722 11.7283 18.1203 14 18.1203C16.2717 18.1203 18.1198 16.2722 18.1198 14.0005Z",
    fill: "#5F7BAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8802 9.88068C21.6086 9.88068 19.7604 11.7288 19.7604 14.0004C19.7604 16.2721 21.6086 18.1202 23.8802 18.1202C26.1519 18.1202 28 16.2722 28 14.0005C28 11.7288 26.1519 9.88068 23.8802 9.88068Z",
    fill: "#5F7BAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2396 14.0005C8.2396 11.7288 6.39149 9.88074 4.11983 9.88074C1.84811 9.88068 0 11.7288 0 14.0005C0 16.2722 1.84811 18.1203 4.11977 18.1203C6.39144 18.1203 8.2396 16.2722 8.2396 14.0005Z",
    fill: "#5F7BAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9401 9.56374C21.2118 9.56374 23.0599 7.71563 23.0599 5.44396C23.0599 3.1723 21.2118 1.32419 18.9401 1.32419C16.6685 1.32419 14.8203 3.1723 14.8203 5.44396C14.8203 7.71563 16.6685 9.56374 18.9401 9.56374Z",
    fill: "#5F7BAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05991 18.4372C6.78825 18.4372 4.94014 20.2853 4.94014 22.557C4.94014 24.8286 6.78825 26.6767 9.05991 26.6767C11.3316 26.6767 13.1797 24.8287 13.1797 22.557C13.1797 20.2854 11.3316 18.4372 9.05991 18.4372Z",
    fill: "#5F7BAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05817 9.56327C11.3298 9.56327 13.1779 7.71516 13.1779 5.4435C13.1779 3.17183 11.3298 1.32367 9.05817 1.32367C6.7865 1.32367 4.93834 3.17178 4.93834 5.44344C4.93834 7.71511 6.7865 9.56327 9.05817 9.56327Z",
    fill: "#5F7BAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9401 18.4372C16.6685 18.4372 14.8204 20.2853 14.8204 22.557C14.8204 24.8286 16.6685 26.6767 18.9401 26.6767C21.2118 26.6767 23.0599 24.8286 23.0599 22.557C23.0599 20.2853 21.2118 18.4372 18.9401 18.4372Z",
    fill: "#5F7BAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegumes);
export default __webpack_public_path__ + "static/media/legumes.44aca1f90c5269716b9fba4b6e2ebc99.svg";
export { ForwardRef as ReactComponent };